module.exports = __webpack_public_path__ + "img/demo01.58c3da9f.jpg";